import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

interface LawyerMeetingsParams {
  limit?: number;
}

export function useLawyerMeetings({ limit = 10 }: LawyerMeetingsParams = {}) {
  return useQuery({
    queryKey: dashboardQueryKeys.lawyerMeetings(limit),
    queryFn: () => dashboardApi.getLawyerMeetings({ limit }),
    // Keep the current rows on screen while a bigger page loads (no skeleton flash).
    placeholderData: keepPreviousData,
  });
}
